'use client';

import React, { useState } from 'react';
import { ApiRoutes } from '@/settings/routes';
import { FaCircleChevronRight } from 'react-icons/fa6';
import Button from '@/components/ui/forms/Button';
import ButtonLoading from '@/components/ui/forms/ButtonLoading';
import Textarea from '@/components/ui/forms/Textarea';
import Input from '@/components/front/ui/Input';
import Success from '@/components/ui/alerts/Success';
import Errors from '@/components/ui/alerts/Errors';
import Error from '@/components/ui/alerts/Error';
import axios from '@/lib/axios';
import { App_text } from '@/settings/AppText';
import Label from '@/components/ui/forms/Label';

export default function ContentContactPage() {
    const [error, setError] = useState('');
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState('');
    const [processing, setProcessing] = useState(false);
    const [formContact, setFormContact] = useState({
        name: '',
        subject: '',
        email: '',
        message: '',
    });

    const handelInput = (e) => {
        e.persist();

        let { name, value } = e.target;
        setFormContact({ ...formContact, [name]: value });
    };

    const submitForm = async (e) => {
        e.preventDefault();

        setProcessing(true);
        setError('');
        setErrors([]);

        axios
            .post(ApiRoutes.API_contact_us, formContact)
            .then((res) => {
                setProcessing(false);
                if (res.data.status === 200) {
                    setSuccess(res.data.message);
                    setFormContact({
                        name: '',
                        email: '',
                        message: '',
                    });
                } else if (res.data.status === 401) {
                    setErrors(res.data.errors);
                    setSuccess('');
                    setError('');
                }
            })
            .catch((error) => {
                setProcessing(false);
                if (error.response.status === 422) {
                    setError('whoops!! something went wrong , please try later');
                    setSuccess('');
                    setErrors([]);
                }
                console.log(error);
            });
    };

    return (
        <div className="relative">
            <Errors errors={errors} />
            <Error message={error} />
            <Success message={success} />
            <form onSubmit={submitForm} className="flex flex-col gap-6">
                <div className="flex flex-col gap-6 md:flex-row">
                    <div className="w-full md:w-1/2">
                        <Label className="!text-base">Your Name:</Label>
                        <Input
                            onChange={handelInput}
                            defaultValue={formContact.name}
                            name="name"
                            type="text"
                            placeholder="Your Name*"
                            className={'text-base rounded-lg focus:!border-main-color focus:!ring-main-color'}
                        />
                    </div>
                    <div className="w-full md:w-1/2">
                        <Label className="!text-base">Your Question: Subject:</Label>
                        <Input
                            onChange={handelInput}
                            defaultValue={formContact.subject}
                            name="subject"
                            type="text"
                            placeholder="Subject*"
                            className={'text-base rounded-lg focus:!border-main-color focus:!ring-main-color'}
                        />
                    </div>
                </div>
                <div className="w-full">
                    <Label className="!text-base">Your Email:</Label>
                    <Input
                        onChange={handelInput}
                        defaultValue={formContact.email}
                        name="email"
                        type="email"
                        placeholder="Email Address*"
                        className={'text-base rounded-lg focus:!border-main-color focus:!ring-main-color'}
                    />
                </div>
                <div className="w-full">
                    <Label className="!text-base">Your Message:</Label>
                    <Textarea
                        onChange={handelInput}
                        defaultValue={formContact.message}
                        name="message"
                        placeholder="Your Message*"
                        rows={5}
                        required
                        className={'text-base rounded-lg focus:border-main-color focus:!ring-main-color'}
                    />
                </div>
                <div className="w-full">
                    {processing === false ? (
                        <Button type="submit" className={`flex items-center w-full gap-2 text-sm font-semibold text-white transition-colors btn ounded-md group btn hover-bg`}>
                            <span>{App_text.generale.button_contact}</span>
                            <FaCircleChevronRight className="size-4 " />
                        </Button>
                    ) : (
                        <ButtonLoading className="flex items-center justify-center px-6 py-3 h-12 w-44 !bg-custom-green" />
                    )}
                </div>
            </form>
        </div>
    );
}
